import axios from 'axios'
import { format, isSameDay } from 'date-fns'
import {
  oneWay as storageOneWay, pickupBusiness, pickupDate, pickupTime, dropBusiness, dropDate, dropTime,
} from '../../utils/setLocalStorage'

// initial state
const bookingState = {
  oneWayAvailable: false,
  oneWay: false,
  cities: [],
  selectedReturnBusiness: '',
  preventDepartureList: false,
  preventReturnList: false,
  pickUp: {
    business: null,
    date: null,
    time: null,
  },
  drop: {
    business: null,
    date: null,
    time: null,
  },
  history: null,
  businessLocalStorageChecked: false,
}

// actions
const actions = {
  GET_BUSINESS_INFO({ commit, rootState }, { pickup, drop }) {
    if (pickup === drop) {
      axios(`${rootState.api}/businesses/${pickup}`).then((res) => {
        commit('SET_PICKUP_BUSINESS', res.data.data)
        commit('SET_DROP_BUSINESS', res.data.data)
      }).finally(() => commit('SET_BUSINESS_LOCAL_STORAGE_CHECKED_TRUE'))
      return
    }

    Promise.all([
      axios(`${rootState.api}/businesses/${pickup}`).then((res) => commit('SET_PICKUP_BUSINESS', res.data.data)),
      axios(`${rootState.api}/businesses/${drop}`).then((res) => commit('SET_DROP_BUSINESS', res.data.data)),
    ]).finally(() => commit('SET_BUSINESS_LOCAL_STORAGE_CHECKED_TRUE'))
  },
  GET_BOOKING_HISTORY({ rootState, commit }) {
    if (!rootState.rrsAvailable) {
      return
    }
    axios(`${rootState.api}/booking-history`).then((res) => commit('SET_HISTORY', res.data.data))
  },
  SET_ONEWAY_STATE({ commit }, oneWayState) {
    if (oneWayState) {
      commit('SET_ONEWAY_AVAILABLE', true)
      return
    }
    commit('SET_ONEWAY_AVAILABLE', false)
    commit('SET_ONEWAY', false)
  },
}

const mutations = {
  SET_ONEWAY_AVAILABLE(state, oneWayAvailable) {
    state.oneWayAvailable = oneWayAvailable
  },
  SET_ONEWAY(state, oneWay) {
    state.oneWay = oneWay
    storageOneWay(oneWay)
  },
  SET_PICKUP_BUSINESS(state, business) {
    state.pickUp.business = business
    pickupBusiness(business.id)
  },
  SET_PICKUP_DATE(state, date) {
    state.pickUp.date = date
    pickupDate(date)
  },
  SET_PICKUP_TIME(state, time) {
    state.pickUp.time = time
    pickupTime(time)
  },
  SET_DROP_BUSINESS(state, business) {
    state.drop.business = business
    dropBusiness(business.id)
  },
  SET_DROP_DATE(state, date) {
    state.drop.date = date
    dropDate(date)
  },
  SET_DROP_TIME(state, time) {
    state.drop.time = time
    dropTime(time)
  },
  SET_HISTORY(state, data) {
    state.history = data
  },
  SET_NO_RETURN_BUSINESSES_WARN_VISIBILITY(state, bool) {
    state.noReturnAgenciesWarn = bool
  },
  SET_RETURN_BUSINESSES(state, businessArray) {
    state.returnBusinesses = businessArray

    if (state.selectedReturnBusiness) {
      const returnBusiness = state.returnBusinesses.find(
        ({ id }) => id === state.selectedReturnBusiness.id,
      )

      state.selectedReturnBusiness.noVU = returnBusiness
        ? returnBusiness.noVU
        : false
    }
  },
  SET_GETTING_RETURN_BUSINESSSES(state, bool) {
    state.gettingReturnBusinessses = bool
  },
  SET_PREVENT_DEPARTURE_LIST(state, bool) {
    state.preventDepartureList = bool
  },
  SET_PREVENT_RETURN_LIST(state, bool) {
    state.preventReturnList = bool
  },
  SET_BUSINESS_LOCAL_STORAGE_CHECKED_TRUE(state) {
    state.businessLocalStorageChecked = true
  },
  SET_BUSINESS_LOCAL_STORAGE_CHECKED_FALSE(state) {
    state.businessLocalStorageChecked = false
  },
}

// getters
const getters = {
  datesAndBusinessReady(state) {
    return (
      state.pickUp
            && state.drop
            && state.pickUp.business
            && state.pickUp.date
            && state.pickUp.time
            && (!state.oneWay || state.drop.business)
            && state.drop.date
            && state.drop.time
    )
  },
  formattedToFromDate(state) {
    if (!state.pickUp.date || !state.drop.date || state.pickUp.time === null || state.drop.time === null) {
      return ''
    }
    const formattedPickupDate = format(state.pickUp.date, 'dd/MM/yyyy')
    const formattedDropDate = format(state.drop.date, 'dd/MM/yyyy')

    return `Du ${formattedPickupDate} à ${state.pickUp.time} au ${formattedDropDate} à ${state.drop.time}`
  },
  pickUpBusinessCityLabel(state) {
    return state.pickUp.business?.city?.label
  },
  isSameDayDrop(state) {
    if (!state.pickUp?.date || !state.drop?.date) {
      return false
    }
    return isSameDay(state.pickUp.date, state.drop.date)
  },
}

export default {
  namespaced: true,
  state: bookingState,
  getters,
  actions,
  mutations,
}
